import React from 'react';
import * as Fi from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';

import { Skeletons, SkeletonText } from 'ui/components/skeleton';

import { formatDate, currencyFormat } from 'utilities/common';
import { Payment } from 'services/action';
import { FormPayment } from '../form';
import { isNotClient } from 'utilities/common';

export const PaymentList = ({ order, onSubmit, privilege }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateForm = useSelector((state) => state?.Form);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const [payments, setPayments] = React.useState(null);
  const [showPayment, setShowPayment] = React.useState(false);
  const [showDelete, setShowDelete] = React.useState(false);
  const [temp, setTemp] = React.useState(null);

  const $onLoad = async() => {
    const req = await Dispatch(Payment.$getByOrder(order?.id));

    if (req?.message === 'success') {
      setPayments(req?.data);
    }
  }

  const $handleDelete = async (val) => {
    setShowDelete(true);
    setTemp(val);
  };

  const $handleUpdate = async (val) => {
    setShowPayment(true);
    setTemp(val);
  };

  const $emitDelete = async () => {
    const req = await Dispatch(Payment.$delete(order?.id, temp?.id));

    if (req?.message === 'success') {
      onSubmit();
      setTemp(null);
      setShowDelete(false);
    }
  };

  React.useEffect(() => {
    if (!order) return
    $onLoad()
  }, [order])

  return (
    <div>
      {StateLoading ? (
        <div className="mb-3">
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
          <Skeletons height="150px" />
        </div>
      ) : (
        <div>
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Log Pembayaran
          </div>

          {payments?.length > 0 ? (
            <div className="log-container border-0 pt-2">
              {payments
                ?.map((d, i) => (
                  <div
                    key={i}
                    className="border-bottom py-2 pe-2 row m-0 align-items-start"
                  >
                    <div className="col-1 p-0">
                      <Fi.FiCheckCircle color="#2fb344" />
                    </div>
                    <div className="col-7 p-0">
                      <div className="text-start title fs-8 fw-semibold">
                        Pembayaran Diterima
                      </div>
                      <div className="text-success fs-8 fw-semibold">
                        {currencyFormat(d?.nominal, 'IDR')}
                      </div>
                      <div className="fs-9 fw-semibold">
                        {d?.paid_by}
                      </div>
                    </div>
                    <div className="col-4 p-0 text-end">
                      <small className="fs-8 text-primary">
                        {formatDate(d?.paid_at)}
                      </small>{' '}
                      {privilege && !isNotClient(Session?.client?.id, order?.client?.id) && (
                        <div className="ms-n3">
                          <button
                            type="button"
                            className="btn btn-danger btn-xs me-2"
                            onClick={() => $handleDelete(d)}
                          >
                            Hapus
                          </button>
                          <button
                            type="button"
                            className="btn btn-xs"
                            onClick={() => $handleUpdate(d)}
                          >
                            Edit
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))
                .reverse()}
            </div>
          ) : (
            <div className="hr-text text-italic mt-4 mb-5"> belum ada </div>
          )}
        </div>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={() => {
          setTemp(null);
          setShowDelete(false);
        }}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={() => {
              setTemp(null);
              setShowDelete(false);
            }}
          />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={() => {
                  setTemp(null);
                  setShowDelete(false);
                }}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={() => $emitDelete()}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* payment */}
      <Modal
        show={showPayment}
        onHide={() => setShowPayment(false)}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Pembayaran</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormPayment
            id={order?.id}
            data={temp}
            onSubmit={() => {
              onSubmit();
              setShowPayment(false);
              setTemp(null);
            }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
